import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AtlasProLanding from './components/AtlasProLanding';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<AtlasProLanding />} />
        <Route path="/atlas-pro" element={<AtlasProLanding />} />
        {/* Add other routes here */}
      </Routes>
    </Router>
  );
}

export default App; 
